const REGISTER_URL = '/api/user/signup';
const LOGIN_URL = '/api/user/login';
const USERAUTH_URL = '/api/user/auth';
const VALIDATE_URL = '/api/validate';
const USERCALL_URL = '/api/user/username';
const MGEN_QR = '/api/mgen/qr';
const MGEN_URL = '/api/mgen';

export {REGISTER_URL, LOGIN_URL, USERAUTH_URL, VALIDATE_URL, USERCALL_URL, MGEN_QR, MGEN_URL};